export const formatPhoneNumber = (phoneNumber: string) =>
    phoneNumber?.replace(/^(\+\d) (\d{3}) (\d{3}) (\d{2}) (\d{2})$/, '$1 ($2) $3-$4-$5') ?? phoneNumber;
